import React, { useState, useContext, useEffect } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import classNames from 'classnames';
import { useSwipeable } from 'react-swipeable';

import { Default, Mobile } from '@helpers/breakpoints';
import PageContext from '@contexts/PageContext';
import { getBackupImg } from '@helpers/dataExists';
import { Container, Button, Modal } from '@components';
import PlayIcon from '@assets/icon/Polygon.svg';
import Fullscreen from '@assets/icon/fullscreen-selected.svg';
import styles from './Video.module.scss';

const DynamicImage = dynamic(() => import('@components/DynamicImage'), {
  ssr: false
});

const Video = ({ data, id, componentIsAvailable, showTitle, componentTitle }) => {
  const pageData = useContext(PageContext);
  const router = useRouter();
  const { locale } = router;
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [current, setCurrent] = useState(0);

    /*Note: change true to false for checking component Dynamically*/
  const [showOnFrench, setShowOnFrench] = useState(true);

  useEffect(() => {
    //check componnet enabled in french /english
    const DisplayValue = data?.DisplayOptions?.find((x) => x.DisplayOptionKey == 'DisplayComponent').OptionInformation;
    if (DisplayValue === true) {
      if (locale == 'fr') {
        setShowOnFrench(true);
      } else {
        setShowOnFrench(true);
      }
    } else {
      if (locale == 'fr') {
          /*Note: change true to false for checking component Dynamically*/
        setShowOnFrench(true);
      } else {
        setShowOnFrench(true);
      }
    }
  }, []);

  //get video array
  const getVideoArr = pageData.ProductGallery.find((item) => item.Description === 'Video');

  //productGalleryContent
  const productGalleryContent = getVideoArr?.GalleryItems.map((gItem) => gItem.ProductGalleryContent);

  const fakeUrl = `/api/static/media/byFile/Promotions/2255_Kubota_M8_Homepage.jpg`;

  const openModel = (id) => {
    //find certain video
    const relatedVideo = productGalleryContent?.find((item) => item.ProductGalleryId == id);
    setShowModal(true);
    setModalData(relatedVideo);
  };

  useEffect(async () => {
    await getBackupImg();
  });

  useEffect(() => {
    thumbnailEventHandler(current);
  }, [current]);

  const thumbnailEventHandler = (inx) => {
    setCurrent(inx);
  };
  const handlers = useSwipeable({
    onSwipedLeft: () => {
      setCurrent(current === 0 ? productGalleryContent.length - 1 : current - 1);
    },
    onSwipedRight: () => {
      setCurrent(current === productGalleryContent.length - 1 ? 0 : current + 1);
    },
    preventDefaultTouchmoveEvent: true,
    trackMouse: true
  });

  return (
    (componentIsAvailable && showOnFrench) && (
      <section className={styles.Section} id={id}>
        <Container className={styles.Container}>
          {showTitle && <h2 className={styles.Title}>{componentTitle}</h2>}
          <Default>
            <div className={styles.Video}>
              {/* {productGalleryContent && (
                <div className={styles.bigTile}>
                  <>
                    {!productGalleryContent[0].ThumbnailUrl ? (
                      <DynamicImage imgSrc={fakeUrl} size={'1920X540'} />
                    ) : (
                      <img
                        src={
                          `/api/static/media/byFile` +
                          productGalleryContent[0].ThumbnailUrl
                        }
                        width="100%"
                        height="100%"
                      />
                    )}
                    <Button
                      animated
                      className={styles.PlayVideo}
                      onClick={() => {
                        openModel(productGalleryContent[0].ProductGalleryId);
                      }}
                    >
                      <label> PLAY VIDEO </label>
                      <PlayIcon />
                    </Button>
                  </>
                </div>
              )} */}
              {productGalleryContent?.length > 0 ? (
                <div className={styles.ListContainer}>
                  <div className={styles.List}>
                    {productGalleryContent.map((video, index) => {
                      if (!video.ThumbnailUrl) {
                        return <img src={fakeUrl} width="100%" height="100%" key={index} />;
                      } else {
                        return (
                          <div
                            className={styles.Tile}
                            key={index}
                            onClick={() => {
                              openModel(video.ProductGalleryId);
                            }}
                          >
                            <div className={styles.Thumbs}>
                              <img
                                className={styles.Image}
                                src={`/api/static/media/byFile` + video.ThumbnailUrl}
                                width="100%"
                                height="100%"
                              />

                              <PlayIcon className={styles.PlaySVG} />
                              <Fullscreen className={styles.Fullscreen} />
                            </div>
                            {/* Uncomment h3, to show Title under small video tiles  */}
                            <h3 className={styles.Name}>{video.Description}</h3>
                          </div>
                        );
                      }
                    })}
                  </div>
                </div>
              ) : null}

              <Modal
                data={modalData}
                show={showModal}
                onHide={() => setShowModal(false)}
                type="LightBox"
                solidBg="true"
                player="true"
                sourceComponent="Video"
                ParentData={productGalleryContent}
              />
            </div>
          </Default>
          <Mobile>
            <>
              <div className={styles.Video} {...handlers}>
                {productGalleryContent && (
                  <div className={styles.bigTile}>
                    <>
                      {productGalleryContent.map((video, index) => {
                        return (
                          <React.Fragment key={index}>
                            {!productGalleryContent[index].ThumbnailUrl ? (
                              <DynamicImage imgSrc={fakeUrl} sizes={'1920X540'} />
                            ) : (
                              <React.Fragment key={index}>
                                {index === current && (
                                  <>
                                    <img
                                      src={
                                        `/api/static/media/byFile` +
                                        productGalleryContent[index].ThumbnailUrl
                                      }
                                      width="100%"
                                      height="100%"
                                    />
                                    <Button
                                      animated
                                      className={styles.PlayVideo}
                                      onClick={() => {
                                        openModel(productGalleryContent[index].ProductGalleryId);
                                      }}
                                    >
                                      <label> PLAY VIDEO </label>
                                      <PlayIcon />
                                    </Button>
                                  </>
                                )}
                              </React.Fragment>
                            )}
                          </React.Fragment>
                        );
                      })}
                    </>
                  </div>
                )}
                {productGalleryContent?.length > 1 ? (
                  <div className={styles.ThumbsList}>
                    {productGalleryContent.map((video, index) => {
                      return (
                        <div
                          key={index}
                          index={index}
                          className={classNames(index === current ? styles.Active : styles.MobileThumbs)}
                          onClick={() => thumbnailEventHandler(index)}
                        ></div>
                      );
                    })}
                  </div>
                ) : null}

                <Modal
                  data={modalData}
                  title={modalData.Description}
                  show={showModal}
                  type="LightBox"
                  solidBg="false"
                  player="true"
                  sourceComponent="Video"
                  onHide={() => setShowModal(false)}
                  ParentData={productGalleryContent}
                ></Modal>
              </div>
            </>
          </Mobile>
        </Container>
      </section>
    )
  );
};

export default Video;
